module.exports = __webpack_public_path__ + "static/img/107_TO8_1797_og.b8df4e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/107_TO8_1797_og.jpg
// module id = K3sw
// module chunks = 0